import React, {useEffect, useRef, useState} from "react";
import NFTHeader from "@/components/NFTHeader";
import Styles from './index.module.scss'
import ListView from "@/components/AntListView";
import NFTModal from "@/components/NFTModal";
import GuardsGetConfirmModal from "@/view/culturalExchange/guardsGetConfirmModal";
import {hideLoading, showLoading} from "@/components/loading";
import {Toast} from "antd-mobile";
import Service from '../service'

const ThirteenGuards = () => {
  const pageDom = useRef(null);
  const [dataSource, setDataSource] = useState([]);
  const [hasMore, setHasMore] = useState(false);
  const currentPage = useRef(1);
  const [canGet, setCanGet] = useState(false)
  const [haveGet, setHaveGet] = useState(false)
  const [stock, setStock] = useState(0)

  const loadData = async (isRefesh=false) => {
    try {
      isRefesh && showLoading();
      const res = await Service.meetClaimService();
      isRefesh && hideLoading();
      console.log(res)
      if (res.code !== '000000') throw res.msg;
      if(Object.keys(res?.data).length > 0) {
        setCanGet(res.data[-1]?.redeemable)
        setHaveGet(res.data[-1]?.isHas)
        setStock(res.data[-1]?.stock)
        delete res.data["-1"];
        setDataSource(Object.values(res.data))
      }
    } catch (error) {
      isRefesh && hideLoading();
      Toast.show(error);
    }
  }
  useEffect(() => {
    loadData(true)
  }, []);
  const renderItem = (item) => {
    return (
      <div className={Styles.item_card}>
        <img className={Styles.img_box} src={item?.imageBg} alt=""/>
        <div className={Styles.row_des}>
          <div className={Styles.left_text}>{item.collectionName}</div>
          <div className={Styles.right_text}>数量: {item?.num}</div>
        </div>
      </div>
    )
  }
  const loadMore = async () => {
    currentPage.current += 1;
  }
  const handleGet = () => {
    const ModalInstance = NFTModal.show({
      content: <GuardsGetConfirmModal
        onClose={() => ModalInstance?.close()}
        successCallBack={() => {
          loadData(true)
        }}
      />,
      getContainer: pageDom.current,
    });
  }
  return (
    <div className={Styles.guardsPage} ref={pageDom}>
      <NFTHeader
        midText="十三太保图鉴"
        bgColor="#FFFFFF"
      />
      <div className={Styles.guardsPage_container}>
        <ListView
          dataSource={dataSource}
          renderItem={renderItem}
          hasMore={hasMore}
          isLoad={true}
          onRefresh={()=>{
            currentPage.current = 1;
            loadData()
          }}
          onEndReached={loadMore}
        />
      </div>
      <div className={Styles.guardsPage_bottom_btn}>
        <div className={Styles.stockText}>限量领取 当前剩余：{stock} 个</div>
        {haveGet ? <button disabled={true} className={Styles.btn} style={{ background: '#C2C2C2'}}>已领取</button>
          : <button disabled={!canGet || !stock} style={{ background: canGet && stock ? '' : '#C2C2C2'}} className={Styles.btn} onClick={handleGet}>集齐领取藏品</button>
        }
      </div>
    </div>
  )
};
export default ThirteenGuards